import React from "react";

export enum GrowthbookFeatures {
  TanyaBrandAdsBanner = "tanya_display_ads_on_web",
  TanyaVideoAds = "tanya_video_ads",
  UserFeedback = "user_feedback_feature",
  identifyDeviceMemoryCohort = "identify_device_memory_cohort",
  identifyDeviceConnectionType = "identify_device_connection_type",
  captureSearchResultVideoClick = "capture_search_result_video_click",
  qnaInteraction = "qna_interaction",
  SlotSelectionSkipButton = "slot_selection_skip_button",
  VacationPeriod = "vacation_feature",
  scheduleChangesInfo = "schedule_changes_info",
  captchaProtection = "captcha_protection",
  slotSelectionUnavailableTeacherInfo = "slot_selection_unavailable_teacher_info",
  smartfestComingSoon = "smartfest_coming_soon"
}

export interface IFeatureVariation {
  variationId: number;
  component: React.ReactNode;
}

export interface IGrowthbookFeatureWrapperProps {
  timeout?: number;
  fallback?: React.ReactNode;
  variations: IFeatureVariation[];
  feature: string;
}

export type IGrowthbookFeatureVariationsProps = Pick<
  IGrowthbookFeatureWrapperProps,
  "variations" | "feature" | "fallback"
>;

export type ITanyaVideoAdsExperimentValue = {
  showThirdPartyAds: boolean;
  showInhouseAds: boolean;
  inHouseAdData?: InHouseAdDataItem[];
};

export type InHouseAdDataItem = {
  src: string;
  type?: string;
  uiData: InhouseAdUIMetaData;
  metaData: InhouseAdMetaData;
};

export type InhouseAdUIMetaData = {
  placement: string;
  skipBtn?: UIMetaData;
  intentBtn?: IntentBtnUIMetaData;
  videoWillPlayNextTag?: UIMetaData;
  skipVideoTag?: UIMetaData;
  adDescription?: UIMetaData;
};

export type InhouseAdMetaData = {
  adId: string;
  adTitle: string;
  isAdSkippable: boolean;
};

export type UIMetaData = {
  titleColor: string;
  title: string;
  appearOffset?: number;
  disappearOffset?: number;
  show: boolean;
  showAdsFreeBottomSheet?: boolean;
  bgColor?: string;
};

export type IntentBtnUIMetaData = UIMetaData & {
  pricingDescription: {
    titleColor: string;
    title: string;
    show: boolean;
    bgColor?: string;
  };
};
export interface IGrowthbookIfFeatureEnabledProps {
  timeout?: number;
  fallback?: React.ReactNode;
  feature: string;
  children: React.ReactNode;
}

export type ITanyaAdsFreePlayBtnTouchpointValue = {
  uninterrupted_videos_threshold: number;
};
